import { createFileRoute } from "@tanstack/react-router";

import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";
import { PlatformClosing } from "@/features/platform/modules/closing/platform-closing";
import { FeaturesHero, FeaturesShowcase } from "@/features/platform/modules/features-page/features-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/features/")({
  head: () => ({
    meta: pageMeta({ title: m.seo_features_title(), description: m.seo_features_description() }),
  }),
  loader: () => ({ crumb: m.platform_nav_features() }),
  component: FeaturesPage,
});

/** What the product does, on its own page rather than only as bands of the landing. */
function FeaturesPage() {
  return (
    <PlatformPage
      head={
        <PlatformHead>
          <FeaturesHero />
        </PlatformHead>
      }
    >
      <FeaturesShowcase />
      <PlatformClosing />
    </PlatformPage>
  );
}
